import { makeStyles } from '@material-ui/core'
import { unwrapResult } from '@reduxjs/toolkit'
import React from 'react'
import { useHistory } from 'react-router-dom'

import { useActionRunner, useNotification } from 'src/modules/notification'
import { Container, PageTitle } from '../../../../../ui'

import { useRecipes } from '../../hooks'

import IngredientForm from '../forms/IngredientForm'

const useStyles = makeStyles(theme => ({
  body: {
    backgroundColor: theme.palette.fadedPurple.main,
    borderRadius: theme.shape.borderRadius,
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
    [theme.breakpoints.up('desktop')]: {
      flexDirection: 'row',
    },
  },
  content: {
    flexGrow: 1,
  },
  inputRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    justifyContent: 'flex-end',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('tablet')]: {
      flexDirection: 'row',
      alignItems: 'center',
    },
  },
  buttonLink: {
    textDecoration: 'none',
  },
}))

const CreateIngredientFormView = () => {
  const { createIngredient } = useRecipes()
  const { showError } = useNotification()

  const history = useHistory()
  const classes = useStyles()

  const [doCreateIngredient] = useActionRunner(createIngredient)

  const onSubmit = async values => {
    const payload = {
      name: values.name,
      unit: values.unit,
      agreement_products: values.products.map(p => p.id),
      external_product:
        values.externalProductName && values.externalProductPrice
          ? {
              name: values.externalProductName,
              price: values.externalProductPrice,
            }
          : {},
    }

    const result = await doCreateIngredient(payload)
    try {
      unwrapResult(result)
      history.push(`/recipes/ingredients`)
    } catch (error) {
      let errorMessage = `You have some errors in your form: \n\n ${
        error.data !== undefined ? error.data['name'] : ''
      }`

      showError(errorMessage)
    }
  }

  return (
    <Container>
      <PageTitle>Ingredient</PageTitle>
      <div className={classes.body}>
        <div className={classes.content}>
          <IngredientForm onSubmit={onSubmit} title="Add Ingredient" />
        </div>
      </div>
      <></>
    </Container>
  )
}

export default CreateIngredientFormView
